import React from 'react';
import { Heading, FontSize, useBreakpoint, HeadingProps } from '@landr/maestro';

interface ResponsiveHeaderProps extends HeadingProps {
    defaultSize?: FontSize;
    mobileSize?: FontSize;
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export const ResponsiveHeader: React.FC<ResponsiveHeaderProps> = ({
    defaultSize,
    mobileSize,
    as = 'h3',
    children,
    ...props
}) => {
    const isMobile = useBreakpoint('md');
    const size = isMobile ? mobileSize : defaultSize;

    return (
        <Heading as={as} size={size} {...props}>
            {children}
        </Heading>
    );
};

export const PageHeader: React.FC<ResponsiveHeaderProps> = ({
    defaultSize = 'jb',
    mobileSize = 'xxl',
    children,
    ...props
}) => (
    <ResponsiveHeader
        as="h1"
        defaultSize={defaultSize}
        mobileSize={mobileSize}
        {...props}
    >
        {children}
    </ResponsiveHeader>
);

export const SectionHeader: React.FC<ResponsiveHeaderProps> = ({
    defaultSize = 'jb',
    mobileSize = 'xxxl',
    children,
    ...props
}) => (
    <ResponsiveHeader
        as="h2"
        defaultSize={defaultSize}
        mobileSize={mobileSize}
        {...props}
    >
        {children}
    </ResponsiveHeader>
);

export const SectionSubHeader: React.FC<ResponsiveHeaderProps> = ({
    defaultSize = 'xl',
    mobileSize = 'xl',
    children,
    ...props
}) => (
    <ResponsiveHeader
        as="h3"
        defaultSize={defaultSize}
        mobileSize={mobileSize}
        {...props}
    >
        {children}
    </ResponsiveHeader>
);

export const ComponentHeader: React.FC<ResponsiveHeaderProps> = ({
    defaultSize = 'xl',
    mobileSize = 'lg',
    children,
    ...props
}) => (
    <ResponsiveHeader
        as="h4"
        defaultSize={defaultSize}
        mobileSize={mobileSize}
        {...props}
    >
        {children}
    </ResponsiveHeader>
);
